import { IRootState } from '../../../store'
import {
  IBackupConfig,
  DEFAULT_BACKUP_CONFIG,
  IAppSettingsEntry,
} from '../../configurations/store/configurations.types'
import { IPcrBackupMetadata } from './pcrBackup.types'

const BACKUP_RETRY_COUNT_KEY = 'BACKUP_RETRY_COUNT'
const BACKUP_DISABLED_KEY = 'PCR_BACKUP_DISABLED'
const BACKUP_INTERVAL_KEY = 'BACKUP_TIME_THRESHOLD_IN_MINS'

export const getCurrentPcrBackupMetadata = (state: IRootState): IPcrBackupMetadata => {
  const metadata = state.pcrBackup
  const currentPcrId = state.home?.pcrId
  if (metadata.pcrId && currentPcrId && metadata.pcrId !== currentPcrId) {
    return { pcrId: currentPcrId, lastSuccessfulBackupTime: null, lastSuccessfulBackupChecksum: null }
  }
  return metadata
}

export const getPcrBackupConfigSelector = (state: IRootState): IBackupConfig => {
  const entries: IAppSettingsEntry[] = state.configurations?.appSettingsEntries ?? []
  const get = (key: string) => entries.find((e) => e.key === key)?.value
  return {
    retryCount: get(BACKUP_RETRY_COUNT_KEY) ?? DEFAULT_BACKUP_CONFIG.retryCount,
    minIntervalMinutes: get(BACKUP_INTERVAL_KEY) ?? DEFAULT_BACKUP_CONFIG.minIntervalMinutes,
    disabled: !!get(BACKUP_DISABLED_KEY),
  }
}
